import request, { IWorkspaceResponse } from './http/Xrequest '

// 报告列表分页
export const getReportPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline-job/reports/page'
  const result = await request.post(url, body)
  return result.data
}

// 计划任务分页
export const getPlanPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline-job/wayline-job-page'
  const result = await request.post(url, body)
  return result.data
}

// 上传报告
export const getUploadReport = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline-job/jobs/upload-report'
  const result = await request.post(url, body)
  return result.data
}

// 获取启用的模板列表
export const getEnabledTemplates = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/enabled'
  const result = await request.get(url)
  return result.data
}

// 生成周报
export const exportTemplateWeekReport = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/export-week-report'
  const result = await request.post(url, body)
  return result.data
}
